export default __webpack_public_path__ + "static/creators-illustration-dark-bb99561f73923913aca4b1874cb274b6.svg";